<template>
  <div class="category-wrap">
    <!-- 商品分类 -->
    <dg-classify></dg-classify>
    <!-- 引入公共footer -->
    <common-footer></common-footer>
  </div>
</template>
<script>
  import DgClassify from './components/classify-tabbar'
  import CommonFooter from "@/components/footer"
  import DgSearch from '@/components/search'
  export default {
    data() {
      return {
        active: 0,
        searchStr: '',
        refresh: false
      };
    },
    components: {
      DgClassify,
      CommonFooter,
      DgSearch,
    },
    methods: {
      handlerStr(str) {
        this.searchStr = str;
      },
    }
  };
</script>
<style lang="scss" >
.category-wrap{
  overflow: hidden;
}
   .search-box {
    width: 100%;
    max-width: 750px;
    height: 88px;
    background: $bg01;
    overflow: hidden;
    position: fixed;
    z-index: 999;
    top: 0;
    .input-box{
      display: flex;
      width: 620px;
      height: 68px;
      border-radius: 34px;
      padding-left: 30px;
      padding-right: 30px;
      margin: 0 auto;
      margin-top: 10px;
      box-shadow: 2px 2px 16px rgba(0,0,0,0.08);
      z-index: 999;
      position: relative;
      background: $bg02;
    }
    .search-btn{
      width: 40px;
      height: 100%;
      background-image: url("../../../assets/images/search-icon.png");
      background-size: 40px 40px;
      background-repeat: no-repeat;
      background-position: 0 14px;
    }
    input{
      flex: 1;
      font-size: 28px;
      color: $fc03;
      padding-left: 10px;
    }
  }
</style>


